import 'regenerator-runtime/runtime';

import './old_index';

import { handleRefs, handleRefsBr } from "@studybay/common-client-library"

// Authorization by social
document.addEventListener('DOMContentLoaded', () => {
  let openedWindow = null;
  let onError = null;

  const getDomain = () => {
    let href = document.location.href;
    if (/test\./.test(href)) {
      return 'https://test.studybay.app';
    }
    if (/dev/.test(href)) {
      return `https://${document.location.host.split('.')[0]}.studybay.local`;
    }
    return 'https://studybay.app';
  };

  const setTimezone = () => {
    const timezoneInputs = document.querySelectorAll('[name="timezone"]')
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    timezoneInputs.forEach(input => input.value = timezone)
  }

  const parseMessage = event => {
    if (event.data.type !== 'socialAuth') return;
    const {
      status,
      redirect: redirectUrl,
    } = event.data.payload;

    if (status !== undefined) {
      if (openedWindow && openedWindow.close) openedWindow.close();
      switch (status) {
        case 0: {
          if (redirectUrl !== undefined) {
            window.location.assign(redirectUrl);
          } else {
            window.location.assign(getDomain() + '/home/');
          }
          break;
        }
        case 1: {
          if (typeof onError === 'function') {
            onError();
          }
          break;
        }
        default: break;
      }
      window.removeEventListener('message', parseMessage);
      onError = null;
    }
  };

  const authBySocNetwork = async name => {
    let openerContext = window.open();
    let socRegId = name === 'facebook' ? '1' : '2';
    let projectName = process.env.PROJECT_NAME || 'sb';
    let currentUrl = getDomain();
    let logParams = `/?type_form=${projectName}_contentWritingSocAuth_${socRegId}&reg_url=${currentUrl}`;
    const response = await (
      await fetch(`/auth/getproviderurl/${name}${logParams}/`, {
        method: 'GET',
      })
    ).json();
    window.addEventListener('message', parseMessage);
    openedWindow = openerContext;
    openerContext.location = response.message;

    return new Promise(function (resolve, reject) {
      onError = reject;
    });
  };

  document.querySelectorAll('.popup-login__btn-social').forEach(item => {
    item.addEventListener('click', () => {
      authBySocNetwork(item.dataset.social)
        .catch(error => {
          console.log(error);
        });
    });
  });

  let projectName = process.env.PROJECT_NAME || 'sb'
  const SEO_US_order = 'f15f531f27434972'
  const SEO_BR_order = 'c8a68943f36eda07'

  if (projectName == 'sb') {
    handleRefs(SEO_US_order)
  } else if (projectName == 'br') {
    handleRefsBr(SEO_BR_order)
  }
  setTimezone()
});
